import { render, staticRenderFns } from "./RoadsDropdown.vue?vue&type=template&id=5de80094"
import script from "./RoadsDropdown.vue?vue&type=script&lang=js"
export * from "./RoadsDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports